import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_3 = { class: "table-responsive p-0" }
const _hoisted_4 = {
  key: 0,
  class: "p-5 pe-md-3 d-flex align-items-center ms-md-auto"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_7 = { class: "table align-items-center mb-0" }
const _hoisted_8 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_9 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Email")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Operador Logístico", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Nível", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Status", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Operação", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" }, null, -1)
const _hoisted_16 = { class: "align-middle text-center" }
const _hoisted_17 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_18 = { class: "d-flex px-2 py-1" }
const _hoisted_19 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_20 = { class: "mb-0 text-sm" }
const _hoisted_21 = { class: "align-middle text-center" }
const _hoisted_22 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "badge badge-danger"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "Atualizando", -1)
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onUpdate:modelValue", "onChange"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Selecione um Operador", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("option", { value: "nenhum" }, "Nenhum Operador", -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "d-flex px-2 py-1" }
const _hoisted_34 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_35 = { class: "align-middle text-center text-sm" }
const _hoisted_36 = { class: "form-check form-switch" }
const _hoisted_37 = ["onChange", "onUpdate:modelValue"]
const _hoisted_38 = {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}
const _hoisted_39 = { class: "align-middle text-center" }
const _hoisted_40 = { class: "badge badge-sm text-xs font-weight-bold bg-danger" }
const _hoisted_41 = { class: "text-sm" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user-edit text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_47 = [
  _hoisted_46
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.searchItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchCall(_ctx.searchIKey,_ctx.searchQuery)), ["enter"])),
                  placeholder: "Procurar..."
                }, null, 544), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_8, [
                _createElementVNode("i", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchData('id_operacao'))),
                  class: "fas fa-search"
                })
              ]),
              _createElementVNode("th", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData('username'))),
                  class: "fas fa-search"
                })
              ]),
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (usuario) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(usuario.id), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("h6", _hoisted_20, _toDisplayString(usuario.username), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_21, [
                  (!usuario.editingOperador)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!usuario.operador_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_22, " SEM OPERADOR "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                              (usuario.is_update)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _hoisted_27))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(usuario.operador?.nome_completo), 1)
                            ])),
                        _createElementVNode("i", {
                          class: "fas fa-user-edit text-secondary",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (usuario.editingOperador = true)
                        }, null, 8, _hoisted_28)
                      ], 64))
                    : _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 1,
                        class: "form-control",
                        "onUpdate:modelValue": ($event: any) => ((usuario.operador_id) = $event),
                        onChange: ($event: any) => (_ctx.salvarUnico(usuario))
                      }, [
                        _hoisted_30,
                        _hoisted_31,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operadores, (m) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: m.id,
                            value: m.id
                          }, _toDisplayString(m.nome_completo), 9, _hoisted_32))
                        }), 128))
                      ], 40, _hoisted_29)), [
                        [_vModelSelect, usuario.operador_id]
                      ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h6", {
                        class: _normalizeClass(["text-center text-uppercase mb-0 text-sm badge badge-sm bg-success", {'bg-success': usuario.role=='operador', 'bg-danger': usuario.role=='master' , 'bg-primary': usuario.role=='motorista'}])
                      }, _toDisplayString(usuario.role), 3)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      onChange: ($event: any) => (_ctx.salvarUnico(usuario)),
                      "onUpdate:modelValue": ($event: any) => ((usuario.ativo) = $event)
                    }, null, 40, _hoisted_37), [
                      [_vModelCheckbox, usuario.ativo]
                    ]),
                    _createElementVNode("label", _hoisted_38, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge badge-sm", {'bg-success': usuario.ativo, 'bg-danger': !usuario.ativo}])
                      }, _toDisplayString(usuario.ativo ? 'Ativo' : 'Inativo'), 3)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_39, [
                  _createElementVNode("span", _hoisted_40, _toDisplayString(usuario.operacao_id), 1)
                ]),
                _createElementVNode("td", _hoisted_41, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => (_ctx.getUnico(usuario.id)),
                    class: "mx-3",
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Editar"
                  }, _hoisted_44, 8, _hoisted_42),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => (_ctx.deleteUnico(usuario.id)),
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Apagar"
                  }, _hoisted_47, 8, _hoisted_45)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}